/**
 * Created by Tormi Talv <tormi.talv@ambientia.ee> on 2016-04-27 10:55.
 */

require('../bootstrap');

let Inputmask = require('inputmask');

Inputmask({'mask': '99:99:99'}).mask(document.getElementsByClassName('time'));
Inputmask({'mask': '[9]9[.99]', 'placeholder': ' '}).mask(document.getElementsByClassName('distance'));

$('.quickdistances a').click(function () {
  var textInput = $(this).closest('div').prev('input');
  textInput.val($(this).text());
});

$('#calculateResults').click(function () {
  var knownResult = $('#knownResult').val();
  var knownDistance = $('#knownDistance').val();

  if (knownResult && knownDistance) {
    knownResult = knownResult.split(':');
    knownResult = (+knownResult[0]) * 60 * 60 + (+knownResult[1]) * 60 + (+knownResult[2]);

    $('#min1').text(secondsToHMS(((knownResult * Math.pow((42 / knownDistance), 1.06)) / 42) + 30));
    $('#max1').text(secondsToHMS(((knownResult * Math.pow((42 / knownDistance), 1.06)) / 42) + 60));

    $('#min2').text(secondsToHMS((knownResult * Math.pow((42 / knownDistance), 1.06)) / 42));

    $('#min3').text(secondsToHMS((knownResult * Math.pow((10 / knownDistance), 1.06)) / 10));
    $('#max3').text(secondsToHMS((knownResult * Math.pow((20 / knownDistance), 1.06)) / 20));

    $('#min4').text(secondsToHMS((knownResult * Math.pow((1 / knownDistance), 1.06))));
    $('#max4').text(secondsToHMS((knownResult * Math.pow((5 / knownDistance), 1.06)) / 5));

    $('#min5').text(secondsToHMS((knownResult * Math.pow((0.4 / knownDistance), 1.06)) / 0.4));
    $('#max5').text(secondsToHMS((knownResult * Math.pow((1 / knownDistance), 1.06))));
  }
});

function secondsToHMS(s) {
  var h = Math.floor(s / 3600);
  s -= h * 3600;
  var m = Math.floor(s / 60);
  s -= m * 60;
  s = Math.floor(s);
  return h + ':' + (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
}